import { IconCard } from '@exploration/shared-components';
import styled from 'styled-components';

// --------------------------------------------------------------------------

export const CardContent = styled(IconCard)`
  height: 100%;
`;
